import { Stack, Typography } from "@mui/material";
import { MuiOtpInput } from "mui-one-time-password-input";
import { Controller, ControllerProps } from "react-hook-form-mui";

export interface FormOTPProps extends Omit<ControllerProps, "render"> {
  length?: number;
}

export const FormOTP = ({ length = 4, name, ...props }: FormOTPProps) => {
  return (
    <Controller
      {...props}
      name={name}
      render={({ field, fieldState }) => (
        <Stack spacing={0.6}>
          <MuiOtpInput
            autoFocus
            length={length}
            sx={{
              gap: length > 4 ? 0.4 : 1,
              mt: "2.5rem",
              fontSize: 1.2,
            }}
            value={field.value}
            TextFieldsProps={{
              type: "number",
              disabled: field.disabled,
            }}
            onChange={(value) => {
              field.onChange({
                name,
                target: {
                  value,
                },
              });
            }}
          />
          {fieldState.error && (
            <Typography color="error">{fieldState?.error?.message}</Typography>
          )}
        </Stack>
      )}
    />
  );
};
